const nestedTreeLocale = {
  nestedTree: {
    searchPlaceholder: "Rechercher",
    clearSearchAriaLabel: "Effacer",
    emptyMessage: "Aucun résultat",
  },
};

export type NestedTreeLocale = typeof nestedTreeLocale;
export default nestedTreeLocale;
